import React, {lazy, Suspense} from "react";
import Render from "./render";

const HtmlBlock = lazy(() => import('../../components/htmlBlock/htmlBlock'));
const ImageLayout = lazy(() => import('../../components/imageLayout/imageLayout'));
const Link = lazy(() => import('../../components/link/link'));
const LinkCollection = lazy(() => import('../../components/linkCollection/linkCollection'));
const Media = lazy(() => import('../../components/mediaMobileDesktop/mediaMobileDesktop'));
const Video = lazy(() => import('../../components/video/video'));

/**
 * 
 * 
 * @category Renders
 * @summary Renders the Structured Text components
 * @return {array} Returns correct components
 * 
 */

const RenderComponents = ({data, ...other}) => {
  const map = {
    'DatoCmsComponentLink' : Link,
    'DatoCmsComponentImageLinkCollection' : LinkCollection,
    'DatoCmsComponentMobileDesktopVersion' : Media,
    'DatoCmsComponentTable': HtmlBlock,
    'DatoCmsComponentVideo': Video,
    'DatoCmsComponentImage' : ImageLayout
  };  
  return(
    <Suspense fallback="">
      <Render data={data} map={map} {...other} />
    </Suspense>
  );
};

export default RenderComponents;